function cleanLines(csv: string): string[] {
  return csv.replace(/^\uFEFF/, '').split(/\r?\n/).filter((line) => line.length > 0);
}

function firstCsvCell(line: string): string {
  if (!line.startsWith('"')) return line.split(',', 1)[0] ?? '';
  let value = '';
  for (let index = 1; index < line.length; index += 1) {
    if (line[index] !== '"') {
      value += line[index];
      continue;
    }
    if (line[index + 1] === '"') {
      value += '"';
      index += 1;
      continue;
    }
    break;
  }
  return value;
}

function csvCell(value: string): string {
  return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

export function mergeRedemptionCsv(parts: string[]): string {
  const populated = parts.map(cleanLines).filter((lines) => lines.length > 1);
  if (populated.length === 0) return '';
  const header = populated[0][0];
  const rows = populated.flatMap((lines) => lines.slice(1));
  return `${[header, ...rows].join('\n')}\n`;
}

export function redemptionCodesFromCsv(csv: string): string[] {
  return cleanLines(csv)
    .slice(1)
    .map(firstCsvCell)
    .filter(Boolean);
}

export function codesOnlyCsv(codes: string[]): string {
  return `code\n${codes.map(csvCell).join('\n')}\n`;
}

export function redemptionGroupCsv(
  name: string,
  productName: string,
  seriesName: string,
  codes: string[],
): string {
  const header = ['code', 'product name', 'series', 'redemption name'];
  const rows = codes.map((code) => [code, productName, seriesName, name].map(csvCell).join(','));
  return `${[header.join(','), ...rows].join('\n')}\n`;
}

export function downloadCsv(csv: string, filename: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
